import { Ellipsis, type LucideIcon } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, IconButton } from '@elbklar/ui';

export interface ZeilenAktion {
  label: string;
  icon?: LucideIcon;
  onSelect: () => void;
  /** Löschen und Entfernen: in danger, die Rückfrage stellt der Aufrufer. */
  gefahr?: boolean;
}

/**
 * Die Aktionen einer Tabellenzeile am Handy, hinter „…“.
 *
 * `DataTable` zeigt unter 768 px nur die Spalten mit `mobil`-Platz; die
 * Knopfspalte fiel dort weg, und Bearbeiten, Stilllegen oder Löschen waren am
 * Handy nicht mehr erreichbar (Gegenprüfung D1). Dünne Zusammensetzung aus
 * DropdownMenu und IconButton, als `renderMobil` einer Spalte.
 */
export function ZeilenMenue({ label, aktionen }: { label: string; aktionen: ZeilenAktion[] }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton icon={Ellipsis} label={label} variant="ghost" size="sm" noTooltip onClick={(e) => e.stopPropagation()} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        {aktionen.map((a) => (
          <DropdownMenuItem key={a.label} icon={a.icon} tone={a.gefahr ? 'danger' : 'default'} onSelect={a.onSelect}>
            {a.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
